import VuexEntities from './plugin';

export default defineSchema => { return VuexEntities({ defineSchema }); };
